var $ = require('jQuery');
var OpenRounds = require('../../lib/open-rounds.js');
var store = require('../../lib/store/index.js').default;
var isMobile = require('../../lib/navigation-is-mobile.js');

const Vue = require('vue');
const ToggleSwitch = require('../../lib/components/Shared/ToggleSwitch.vue').default;
const ProgressBar = require('./PicksProgressBar.vue').default;
const Preferences = require('./Preferences/Preferences.vue').default;

module.exports = function () {
  store.commit('topPick/resetState');

  $(document).one('pjax:start', () => {
    store.commit('topPick/resetState');
  });

  if($('#toggle-my-picks-only').length) {
    new Vue({
      el: '#toggle-my-picks-only',
      components: {
        'toggle-switch': ToggleSwitch
      }
    });
  }

  if($('#picks-progress-bar').length) {
    new Vue({
      el: '#picks-progress-bar',
      components: {
        'picks-progress-bar': ProgressBar
      },
      store
    });
  }

  const rows = document.querySelectorAll('.preferences');

  [].forEach.call(rows , (el) => {
    new Vue({
      el: el,
      components: {
        'preferences': Preferences
      },
      store
    });
  });

  new OpenRounds();

  // Filtertron
  $('.filtertron').filtertron('entries', {
    expander: '#filtertronExpander'
  });

  // Score set selector
  $('#scoreSetSelector').on('change', function () {
    var data = 'score-set=' + $(this).val();
    var url = $(this).data('url');
    $.pjax({ url: url, data: data, container: '#pjaxContainer', method: 'GET' });
  });

  // Collapse category selector when it becomes sticky to save vertical space
  $(window).scroll(function () {
    if ($(this).scrollTop() >= $('.header-controls').offset().top) {
      $('#quick-selector-category').addClass('closed');
    } else if ($('#quick-selector-category').hasClass('open')) {
      $('#quick-selector-category').removeClass('closed');
    }
  });

  if (!isMobile()) {
    $('.header-controls').stickybits({
      useStickyClasses: true
    });
  }
};
